(() => {
  if (window.KlaimHeaderPanels) return;
  const html = document.documentElement;
  const header = document.querySelector('#SiteHeaderInner');
  const group = document.querySelector('.header-group');
  if (!header || !group) return;
  const panels = new Map();
  let active = null;
  let locked = null;
  let returnFocus = null;
  const controls = () => [...header.querySelectorAll('[data-klaim-mobile-menu-lab-trigger], #searchButton, #cart-link')];
  const kind = element => element.id === 'cart-link' ? 'cart' : element.id === 'searchButton' ? 'search' : 'menu';
  const visible = element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert], [hidden]');

  function measure() {
    const rect = header.getBoundingClientRect();
    html.style.setProperty('--klaim-panel-top', `${Math.max(0, rect.bottom)}px`);
  }

  function syncControls() {
    controls().forEach(control => {
      const name = kind(control);
      if (!control.dataset.klaimIdleLabel) control.dataset.klaimIdleLabel = control.getAttribute('aria-label') || (name === 'cart' ? 'Cart' : name);
      const pressed = active === name;
      control.setAttribute('aria-expanded', String(pressed));
      control.setAttribute('aria-label', pressed ? `Close ${name === 'cart' ? 'cart' : name}` : control.dataset.klaimIdleLabel);
      control.classList.toggle('klaim-panel-trigger-active', pressed);
      const surface = panels.get(name)?.element;
      if (surface?.id) control.setAttribute('aria-controls', surface.id);
    });
  }

  function lock() {
    if (locked) return;
    const body = document.body;
    const background = [...document.querySelectorAll('#MainContent, .shopify-section-group-footer-group')];
    locked = { y: window.scrollY, viewportWidth: window.innerWidth, styles: ['position', 'top', 'width', 'overflow'].map(key => [key, body.style[key]]), background: background.map(element => [element, element.inert]) };
    html.style.setProperty('--klaim-header-group-top', `${Math.max(0, group.getBoundingClientRect().top)}px`);
    html.style.setProperty('--klaim-header-page-width', `${document.documentElement.clientWidth}px`);
    body.style.position = 'fixed';
    body.style.top = `-${locked.y}px`;
    body.style.width = 'var(--klaim-header-page-width)';
    body.style.overflow = 'hidden';
    html.classList.add('klaim-header-panel-modal');
    background.forEach(element => { element.inert = true; });
    measure();
  }

  function unlock() {
    if (!locked) return;
    const state = locked;
    locked = null;
    state.styles.forEach(([key, value]) => { document.body.style[key] = value; });
    state.background.forEach(([element, inert]) => { element.inert = inert; });
    html.classList.remove('klaim-header-panel-modal');
    window.scrollTo({ top: state.y, left: 0, behavior: 'instant' });
  }

  window.KlaimHeaderPanels = {
    get active() { return active; },
    register(name, adapter) {
      panels.set(name, adapter);
      // The shared header remains part of keyboard navigation, outside each panel.
      const dialog = adapter.element?.matches('[role="dialog"]') ? adapter.element : adapter.element?.querySelector('[role="dialog"]');
      dialog?.removeAttribute('aria-modal');
      dialog?.setAttribute('role', 'region');
      syncControls();
    },
    activate(name, trigger) {
      if (active === name) return;
      const previous = active;
      active = name;
      window.dispatchEvent(new CustomEvent('klaim:header-panel-open'));
      returnFocus = trigger || controls().find(control => kind(control) === name && visible(control)) || document.activeElement;
      panels.get(previous)?.close();
      html.dataset.klaimHeaderPanel = name;
      if (panels.get(name)?.modal !== false) lock();
      else unlock();
      measure();
      syncControls();
    },
    deactivate(name) {
      if (active !== name) return;
      active = null;
      delete html.dataset.klaimHeaderPanel;
      unlock();
      syncControls();
      const focusTarget = returnFocus?.isConnected && visible(returnFocus) ? returnFocus : controls().find(control => kind(control) === name && visible(control));
      focusTarget?.focus({ preventScroll: true });
    }
  };

  document.addEventListener('keydown', event => {
    const panel = panels.get(active);
    if (!panel) return;
    if (event.target?.closest('[data-kqa-root], .kqa-inline')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.close();
      return;
    }
    if (event.key !== 'Tab' || panel.modal === false) return;
    const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
    const elements = [...new Set([...header.querySelectorAll(selector), ...panel.element.querySelectorAll(selector)])].filter(visible);
    const index = elements.indexOf(document.activeElement);
    event.stopImmediatePropagation();
    event.preventDefault();
    // Cart precedes the header in DOM order, so advance through the visual order explicitly.
    const next = index < 0 ? (event.shiftKey ? elements.length - 1 : 0) : (index + (event.shiftKey ? -1 : 1) + elements.length) % elements.length;
    elements[next]?.focus({ preventScroll: true });
  }, true);

  html.classList.add('klaim-header-panels');
  measure();
  new ResizeObserver(measure).observe(header);
  window.addEventListener('resize', () => {
    if (locked && locked.viewportWidth !== window.innerWidth) {
      locked.viewportWidth = window.innerWidth;
      html.style.setProperty('--klaim-header-page-width', `${window.innerWidth}px`);
    }
    measure();
  }, { passive: true });
})();
